import { FONT_LAYOUT, GRID_LAYOUT } from "../../constants/grid.layout";
import { OrderFilterType } from "../../_utils/types";
import { actionTypes } from "../_actions/persist.action";
import { PersistGrid, PersistState } from "../../interfaces";

const initialState: PersistState = {
  selectedPairId: 0,
  depthOption: true,
  favPairList: [],
  ordersFilter: OrderFilterType.CurrentPair,
  showDepositWalletInfo: true,
  showExpiredTKInfo: "",
  delistedPairsChecked: [],
  presalePairChecked: [],
  current_breakpoint: "lg",
  mobile_tab: "MARKET",
  locked_layout: false,
  grid_layout: GRID_LAYOUT,
  font_layout: FONT_LAYOUT,
  old_grid_layout: {} as PersistGrid,
};

const persist = (state = initialState, action): PersistState => {
  switch (action.type) {
    case actionTypes.SAVE_CHANGES_GRID_LAYOUT:
      return {
        ...state,
        grid_layout: action.data,
      };
    case actionTypes.SAVE_OLD_GRID_LAYOUT:
      return {
        ...state,
        old_grid_layout: action.data,
      };
    case actionTypes.SAVE_CHANGES_FONT_SIZE_LAYOUT:
      return {
        ...state,
        font_layout: action.data,
      };

    case actionTypes.SAVE_MOBILE_TAB:
      return {
        ...state,
        mobile_tab: action.data,
      };
    case actionTypes.SAVE_CURRENT_BREAKPOINT:
      return {
        ...state,
        current_breakpoint: action.data,
      };
    case actionTypes.RESET_LAYOUT:
      return {
        ...state,
        grid_layout: initialState.grid_layout,
        font_layout: initialState.font_layout,
        mobile_tab: initialState.mobile_tab,
        old_grid_layout: initialState.old_grid_layout,
        locked_layout: initialState.locked_layout,
      };
    case actionTypes.SAVE_ORDERS_FILTER:
      return {
        ...state,
        ordersFilter: action.data
      }
    case actionTypes.SAVE_LOCK_LAYOUT:
      return {
        ...state,
        locked_layout: action.data
      }
    case actionTypes.SAVE_DEPOSIT_WALLET_INFO:
      return {
        ...state,
        showDepositWalletInfo: action.data
      }
    case actionTypes.SAVE_EXPIRED_TK_INFO:
      return {
        ...state,
        showExpiredTKInfo: action.data
      }
    case actionTypes.SAVE_DELISTED_PAIRS_CHECKED:
      return {
        ...state,
        delistedPairsChecked: action.data,
      };
    case actionTypes.SAVE_PRESALE_PAIRS_CHECKED:
      return {
        ...state,
        presalePairChecked: action.data,
      };
    case actionTypes.SAVE_DEPTH_OPTION:
      return {
        ...state,
        depthOption: action.data,
      };
    case actionTypes.SAVE_FAV_PAIR_LIST:
      return {
        ...state,
        favPairList: action.data,
      };
    case actionTypes.SAVE_SELECTED_PAIR_OPTIONS:
      return {
        ...state,
        selectedPairId: action.data.id,
      };
    default:
      return state;
  }
};

export default persist;
